"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var path_helper_1 = require("../config/path.helper");
var period_model_1 = require("../model/period/period.model");
var operators_1 = require("rxjs/operators");
var category_convert_util_1 = require("../util/category-convert.util");
var from_1 = require("rxjs/observable/from");
/**
 * @author Lernik Mirzoyan.
 * Created on 2019-03-01.
 */
var HttpPeriodGeneratorService = /** @class */ (function () {
    function HttpPeriodGeneratorService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.meServiceUriKey = "me-de-service-url";
        this.meServiceUri$ = from_1.from(this.applicationPropertiesService.getProperty(this.meServiceUriKey));
    }
    HttpPeriodGeneratorService.prototype.getYearId = function (date, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            var params = {};
            if (shiftMonth)
                params['shift-month'] = shiftMonth;
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/years/" + date.getTime(), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getPeriods = function (startDate, endDate, shiftMonth, period, parentPeriod) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS, new period_model_1.Period(startDate, endDate, period, parentPeriod), { params: params })
                .pipe(operators_1.map(function (res) {
                return category_convert_util_1.ConvertUtil.backendPeriodParentToFrontendPeriodParent(res);
            }));
        }));
    };
    HttpPeriodGeneratorService.prototype.getYearIds = function (startDate, endDate, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/years", new period_model_1.Period(startDate, endDate), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getSemiId = function (date, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/semi/" + date.getTime(), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getSemiIds = function (startDate, endDate, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/semi", new period_model_1.Period(startDate, endDate), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getQuarterId = function (date, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/quarters/" + date.getTime(), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getQuarterIds = function (startDate, endDate, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/quarters", new period_model_1.Period(startDate, endDate), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getMonthId = function (date, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/months/" + date.getTime(), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getMonthIds = function (startDate, endDate, shiftMonth) {
        var _this = this;
        if (shiftMonth === void 0) { shiftMonth = 0; }
        var params = {};
        if (shiftMonth)
            params['shift-month'] = shiftMonth;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/months", new period_model_1.Period(startDate, endDate), { params: params });
        }));
    };
    HttpPeriodGeneratorService.prototype.getWeekId = function (date) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/weeks/" + date.getTime());
        }));
    };
    HttpPeriodGeneratorService.prototype.getWeekIds = function (startDate, endDate) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/weeks", new period_model_1.Period(startDate, endDate));
        }));
    };
    HttpPeriodGeneratorService.prototype.getDayId = function (date) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.get(url + path_helper_1.PathHelper.PERIODS + "/days/" + date.getTime());
        }));
    };
    HttpPeriodGeneratorService.prototype.getDayIds = function (startDate, endDate) {
        var _this = this;
        return this.meServiceUri$.pipe(operators_1.switchMap(function (url) {
            return _this.http.post(url + path_helper_1.PathHelper.PERIODS + "/days", new period_model_1.Period(startDate, endDate));
        }));
    };
    HttpPeriodGeneratorService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpPeriodGeneratorService);
    return HttpPeriodGeneratorService;
}());
exports.HttpPeriodGeneratorService = HttpPeriodGeneratorService;
//# sourceMappingURL=http-period-generator.service.js.map